module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("In human intimacy there is a secret barrier: neither the experience of being in love, nor that of passion, can traverse it, even if lips are joined together in terrible silence and the heart breaks to pieces with love.")])]), _vm._v(" "), _c('p', {
    staticClass: "epc-bot"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANNA AKHMATOVA")])]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("This is my letter to the World"), _c('br'), _vm._v("That never wrote to Me")]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EMILY DICKINSON")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a60cfd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraphs.vue
// module id = 69
// module chunks = 0